// import React from "react";
// import { useTranslation } from "react-i18next";
// const ViewPlan = ({ data }) => {
//   const { t } = useTranslation();

//   console.log("data ==>", data);
//   return (
//     <>
//       <div style={styles.container}>
//         {/* <h2 style={styles.title}>{data?.store_name}</h2> */}
//         <table style={styles.table}>
//           <tbody>
//             <tr style={{ borderBottom: "1px dotted black" }}>
//               <td>{t("Title")}</td>
//               <td>{t("Details")}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}> {t("Title")}:</td>
//               <td>{data?.plan_title}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Description")}:</td>
//               <td>
//                 <td>{data?.plan_description}</td>
//               </td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Plan Type")}:</td>
//               <td>{data?.plan_type}</td>
//             </tr>

//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Discount Type")}:</td>
//               <td>{data?.discount_type}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Plan Discount	")}:</td>
//               <td>{data?.plan_discount}</td>
//             </tr>
//             {/* <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Store Location")}:</td>
//               <td>{data?.location?.address}</td>
//             </tr> */}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };
// const styles = {
//   container: {
//     maxWidth: "50rem",
//     minWidth: "50rem",
//     margin: "auto",
//     padding: "20px",
//     // backgroundColor: "#f0f0f0",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },
//   title: {
//     textAlign: "center",
//     color: "#333",
//     marginBottom: "20px",
//   },
//   table: {
//     width: "100%",
//   },
//   label: {
//     fontWeight: "600",
//     paddingRight: "10px",
//     verticalAlign: "top",
//     padding: "1rem",
//   },
//   select: {
//     width: "100%",
//     padding: "8px",
//     borderRadius: "4px",
//     border: "1px solid #ccc",
//     fontSize: "14px",
//     marginTop: "5px",
//   },
// };

// export default ViewPlan;
import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";

const ViewPlan = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  return (
    <div className="flex gap-8">
      <div style={styles.container}>
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>{t("Back")}</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-semibold">
              {t("View Plan")}
            </p>
            <hr className="mb-4" />
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Title")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.plan_title ? data?.plan_title : "---"}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Description")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.plan_description}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Plan Type")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.plan_type}
                </td>
              </tr>
            </div>

            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Discount Type")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.discount_type}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Plan Discount")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.plan_discount}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {/* {t("Location")} */}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {/* {data?.location?.address} */}
                </td>
              </tr>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  );
};
const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
},
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewPlan;
